{
  "actions": {
    "back": "Back"
  },
  "till": {
    "title": "Point of sale",
    "till": "Till",
    "shift": "Shift",
    "cashier": "Cashier",
    "backOffice": "Back office",
    "loading": "Loading the till…",
    "saleArea": "Sale",
    "summary": "Sale summary"
  },
  "menu": {
    "label": "Till menu",
    "sales": "Sales of this shift",
    "return": "Return goods",
    "cashMovement": "Pay in / pay out",
    "xReport": "X report",
    "clear": "Clear sale",
    "switchShift": "Switch shift",
    "closeShift": "Close shift"
  },
  "open": {
    "title": "Open a shift",
    "body": "Choose the till you are working on and count the cash in its drawer.",
    "till": "Till",
    "cashAndCard": "Cash and card",
    "cashOnly": "Cash only",
    "float": "Cash counted in the drawer",
    "floatHint": "Count it now. If it differs from what the books say the drawer holds, the difference is recorded as cash over or short.",
    "submit": "Open shift",
    "noTills": "No till is set up yet",
    "noTillsManage": "Add a till with its warehouse and drawer to start selling.",
    "noTillsAsk": "Ask a manager to set up a till in the back office.",
    "setUp": "Set up tills",
    "inUse": "In use",
    "inUseHint": "A shift is open on this till. It must be closed before another can open."
  },
  "choose": {
    "title": "Choose a shift",
    "body": "You have shifts open on more than one till. Choose the one you are selling on.",
    "named": "Sell on till {{till}}, shift {{number}}"
  },
  "scan": {
    "label": "Barcode, SKU, name or description",
    "placeholder": "Scan, or type a name, SKU, barcode or description",
    "hint": "Matching items appear as you type; Enter adds the highlighted one, or the scanned item. Type 3*code to add three. With the field empty: + and − change the selected line, Delete removes it, ↑ and ↓ move between lines.",
    "looking": "Looking up…",
    "notFound": "Nothing matches “{{code}}”. Check the code or search by name.",
    "noMatches": "No item matches “{{query}}”.",
    "matches": "Matches for “{{query}}”",
    "matchesLabel": "Matching items",
    "matchesHint": "↑ ↓ to choose, Enter to add, Esc to close"
  },
  "cart": {
    "label": "Items in this sale",
    "empty": "Scan the first item",
    "emptyBody": "Scan a barcode, or type a SKU or name and press Enter.",
    "keyAdd": "Add the item",
    "shortcuts": "Keyboard shortcuts",
    "item": "Item",
    "quantity": "Quantity",
    "discount": "Discount",
    "total": "Total",
    "actions": "Line actions",
    "less": "One less {{name}}",
    "more": "One more {{name}}",
    "quantityOf": "Quantity of {{name}}",
    "unitOf": "Unit of {{name}}",
    "edit": "Change price or discount of {{name}}",
    "remove": "Remove {{name}}",
    "priceChanged": "Price changed (catalogue {{price}})",
    "keys": "+ / − change the selected line, Delete removes it, ↑ ↓ select."
  },
  "lines": {
    "quantity": "Quantity",
    "wholeUnits": "Whole units only",
    "serialQuantity": "One per serial number: change the serial numbers on the line (S/N).",
    "price": "Unit price",
    "priceInclusive": "Unit price (incl. VAT)",
    "overrideHint": "Change it only when the shelf price is wrong.",
    "catalogue": "Catalogue price: {{price}}",
    "resetPrice": "Use catalogue price",
    "discount": "Line discount",
    "discountType": "Discount type",
    "discountPercent": "%",
    "discountLine": "Off the line",
    "discountUnit": "Per unit",
    "discountValue": "Discount",
    "saleDiscountSet": "The sale has a discount of its own. Remove it to discount single lines.",
    "lineTotal": "Line total",
    "apply": "Apply",
    "remove": "Remove line"
  },
  "customer": {
    "label": "Customer",
    "title": "Customer for this sale",
    "body": "Choose a named customer, or keep the walk-in customer.",
    "walkIn": "Walk-in customer",
    "walkInName": "Walk-in customer",
    "change": "Customer",
    "clear": "Back to walk-in customer",
    "credit": "Credit",
    "creditHint": "May buy on account: what is not paid stays open on the invoice."
  },
  "saleDiscount": {
    "label": "Discount on sale",
    "none": "None",
    "add": "Add",
    "edit": "Change",
    "remove": "Remove discount",
    "title": "Discount on the whole sale",
    "body": "Spread over the items before VAT. It can't be combined with line discounts.",
    "type": "Discount type",
    "percentage": "Percentage",
    "amount": "Amount",
    "percentValue": "Percentage off",
    "amountValue": "Amount off",
    "discountAmount": "Discount",
    "apply": "Apply discount",
    "percentOff": "{{value}}% off",
    "amountOff": "{{amount}} off",
    "lineDiscounts": "Some lines have their own discount: remove those to discount the whole sale."
  },
  "loyalty": {
    "label": "Points",
    "points_one": "{{points}} point",
    "points_other": "{{points}} points",
    "chip": "Loyalty points",
    "owes": "Owes {{points}}",
    "notMember": "Not a member",
    "blocked": "Blocked",
    "worth": "Worth {{amount}}",
    "redeem": "Redeem",
    "change": "Change",
    "remove": "Remove points",
    "title": "Redeem points",
    "body": "Points come off the sale before VAT.",
    "balance": "Available",
    "rate": "Value",
    "rateValue": "{{points}} = {{amount}}",
    "most": "Most for this sale",
    "field": "Points to redeem",
    "useMax": "Use max",
    "off": "Points off",
    "before": "Before points",
    "apply": "Apply points",
    "reduced": "Reduced to {{points}}, the most this sale allows.",
    "enterPoints": "Enter the points to redeem.",
    "minPoints": "Redeem at least {{points}}.",
    "cannot": "No points can be redeemed on this sale",
    "blocks": {
      "PROGRAM_OFF": "The loyalty programme is switched off.",
      "NOT_MEMBER": "This customer isn't a loyalty member.",
      "MEMBER_BLOCKED": "This member is blocked from redeeming points.",
      "DISCOUNT_CONFLICT": "Points can't be combined with a discount on the whole sale.",
      "BELOW_MIN_SALE": "Points are redeemed only on sales of at least {{amount}}.",
      "BELOW_MIN_POINTS": "The most this sale allows is under the least that can be redeemed ({{points}}).",
      "NO_BALANCE": "Not enough points to redeem."
    },
    "notice": {
      "lowered": "The sale now allows at most {{points}}: the points were lowered to that.",
      "removed": "The points were taken off the sale. {{reason}}",
      "changed": "The customer's points or the programme changed: the sale now takes {{points}} ({{amount}} off). Check the new total with the customer and take payment again.",
      "changedRemoved": "The customer's points or the programme changed, so no points come off this sale now. Check the new total with the customer and take payment again."
    },
    "receipt": {
      "label": "Loyalty points",
      "redeemed": "Points redeemed",
      "released": "Points given back",
      "earned": "Points earned",
      "toEarn": "Points to earn once paid",
      "availableOn": "Can be spent from {{date}}",
      "balance": "Points balance"
    }
  },
  "totals": {
    "label": "Totals",
    "items": "Items",
    "subtotal": "Subtotal",
    "discount": "Discount",
    "vat": "VAT",
    "vatIncluded": "VAT included",
    "total": "Total",
    "beforeDiscount": "Before discount",
    "points": "Points ({{points}})"
  },
  "pay": {
    "button": "Pay",
    "title": "Take payment",
    "total": "To pay",
    "method": "Payment method",
    "cash": "Cash",
    "card": "Card",
    "split": "Split",
    "received": "Cash received",
    "receivedHint": "Leave it empty when the customer pays the exact amount.",
    "quickCash": "Quick cash amounts",
    "exact": "Exact",
    "change": "Change",
    "cardWhole": "The whole amount goes to the card.",
    "reference": "Card slip reference",
    "referenceHint": "Optional: the approval or slip number.",
    "cardPart": "Paid by card",
    "cashPart": "Paid in cash",
    "complete": "Complete sale",
    "nothingDue": "Nothing to pay: the sale comes to zero.",
    "cashShort": "The cash received is less than the {{amount}} due.",
    "cardMissing": "Enter the part paid by card.",
    "cardOverTotal": "The card part is more than the total.",
    "changeTooLarge": "That amount looks wrong: the change would be {{largest}} or more. Was a barcode scanned into it? Correct the cash received.",
    "scanIgnored": "A barcode was scanned into the cash received and was ignored. Scan items on the sale, not here.",
    "cashOnlyTitle": "This till takes cash only",
    "cashOnly": "It has no card account. Take cash, or ask a manager to add a card account to the till.",
    "badQuantity": "Every line needs a quantity above zero.",
    "serialsMissing": "Choose a serial number for each {{name}} sold (S/N on its line) before taking payment.",
    "methodWhole": "The whole amount is paid by {{name}}.",
    "methodPart": "Paid by {{name}}",
    "splitMethod": "Non-cash part paid by",
    "chargeToAccount": "Charge to account",
    "onAccount": "On {{name}}'s account",
    "onAccountHint": "Complete sale needs payment in full. Charge to account takes what is entered and leaves the rest open on the invoice."
  },
  "receipt": {
    "label": "Receipt {{number}}",
    "taxInvoice": "Tax invoice",
    "vatNumber": "VAT No.",
    "crNumber": "CR No.",
    "phone": "Tel.",
    "invoiceNumber": "Invoice",
    "date": "Date",
    "till": "Till",
    "cashier": "Cashier",
    "customer": "Customer",
    "items": "Items",
    "discount": "Discount",
    "discountOf": "Discount {{discount}}",
    "totalDiscount": "Total discount",
    "vatOn": "VAT {{rate}} on {{net}}",
    "total": "Total",
    "vatIncluded": "Prices include VAT.",
    "cashTendered": "Cash received",
    "change": "Change",
    "voidReason": "Voided: {{reason}}",
    "thanks": "Thank you for shopping with us",
    "currency": "Amounts in Omani rials (<rial/>).",
    "done": "Sale complete",
    "voided": "Sale voided",
    "changeDue": "Change due",
    "print": "Print receipt",
    "newSale": "New sale",
    "onAccount": "On account",
    "stillDue": "Still due from {{name}}",
    "nextHint": "Scanning the next item starts a new sale."
  },
  "return": {
    "title": "Return goods",
    "body": "Find the sale by the invoice number on the receipt.",
    "invoiceNumber": "Invoice number",
    "find": "Find sale",
    "notFound": "No till sale has the invoice number “{{number}}”.",
    "candidates": "Matching sales",
    "saleTotal": "Sale total",
    "lines": "Items on the sale",
    "sold": "Sold",
    "returned": "Returned",
    "remaining": "Left",
    "quantity": "Return",
    "quantityOf": "Quantity of {{name}} to return",
    "refund": "Refund",
    "all": "Return everything left",
    "refundTotal": "Refund",
    "method": "Refund method",
    "storeCredit": "Store credit",
    "cashHint": "Paid out of this drawer.",
    "cardHint": "Back to the card the sale was paid with.",
    "cardLeft": "Can still go back to the card:",
    "cardCap": "Only {{amount}} can still go back to the card this sale was paid by. Return fewer items to the card, or refund another way.",
    "cashCap": "Only {{amount}} of this sale was paid in cash and can still go back in cash. More needs a supervisor who may refund any tender.",
    "settlesBalance": "{{amount}} of this return lowers what {{customer}} still owes on the sale; only the rest is refunded.",
    "cashCapNone": "No cash paid on this sale is left to give back, so a cash refund needs a supervisor who may refund any tender.",
    "creditHint": "{{customer}} keeps it as credit for a later purchase.",
    "creditNeedsSales": "Store credit needs the Sales module, which is turned off for your company.",
    "reason": "Reason",
    "chooseLines": "Enter how many of each item come back.",
    "nothingLeft": "Everything on this sale has already been returned.",
    "serialsMissing": "Choose the serial number of each {{name}} coming back (S/N on its line).",
    "otherSale": "Another sale",
    "submit": {
      "CASH": "Refund {{amount}} in cash",
      "CARD": "Refund {{amount}} to card",
      "STORE_CREDIT": "Keep {{amount}} as credit"
    },
    "submitBalance": "Lower the balance owed by {{amount}}",
    "confirmTitle": "Record this return?",
    "confirm": {
      "CASH": "Pay out {{amount}} from the drawer to the customer.",
      "CARD": "Refund {{amount}} to the customer's card.",
      "STORE_CREDIT": "{{customer}} keeps {{amount}} as store credit."
    },
    "confirmBalance": "Nothing is paid back: {{amount}} comes off what {{customer}} still owes on the sale.",
    "done": {
      "CASH": "Return {{number}} recorded: pay out {{amount}} in cash.",
      "CARD": "Return {{number}} recorded: {{amount}} refunded to the card.",
      "STORE_CREDIT": "Return {{number}} recorded: {{amount}} kept as store credit."
    },
    "doneBalance": "Return {{number}} recorded: {{amount}} off what {{customer}} owes; nothing paid back."
  },
  "unlinked": {
    "action": "Return without a receipt",
    "actionHint": "No till sale to find: bought before the till, on an invoice, or the receipt is lost.",
    "body": "Goods with no till sale behind them come back into this till's warehouse at today's price.",
    "back": "Find a sale instead",
    "add": "Item coming back",
    "addPlaceholder": "Scan or search for an item",
    "lines": "Items coming back",
    "empty": "Add the items the customer brings back.",
    "unitPrice": "Unit price",
    "actions": "Actions",
    "quantityOf": "Quantity of {{name}} coming back",
    "priceOf": "Unit price of {{name}}",
    "remove": "Remove {{name}}",
    "priceCap": "A price can be lowered, but not raised above today's selling price.",
    "cardHint": "To this till's card account."
  },
  "returnReceipt": {
    "label": "Return receipt {{number}}",
    "title": "Tax credit note",
    "stamp": "Return",
    "creditNote": "Credit note",
    "invoice": "Original invoice",
    "noSale": "No till sale",
    "total": "Total returned",
    "method": {
      "CASH": "Paid out in cash",
      "CARD": "Refunded to card",
      "STORE_CREDIT": "Kept as store credit"
    },
    "toCard": "Refunded to {{method}}",
    "refundNumber": "Refund no.",
    "reason": "Reason: {{reason}}"
  },
  "returnPanel": {
    "done": "Return recorded",
    "payOut": "Pay out",
    "print": "Print return receipt"
  },
  "rules": {
    "pricesLoading": "Loading this customer's prices. Take payment in a moment.",
    "pricesChanged": "Prices changed since these items were scanned: {{names}}. Check the new total with the customer, then take payment again.",
    "pricesChangedReturn": "Today's prices changed: {{names}}. Check the refund with the customer, then record the return again.",
    "lineProblem": "{{name}}: {{message}}",
    "lineMarked": "Check this line",
    "notSoldInUnit": "This product is no longer sold in this unit.",
    "unitQuantity": {
      "WHOLE_UNITS": "This unit is counted in whole units.",
      "WHOLE_BASE_UNITS": "This quantity makes part of a whole base unit.",
      "BASE_SCALE": "This quantity makes more than 4 decimals of the base unit."
    },
    "returnQuantityOfPack": "Quantity of {{name}} ({{pack}}) to return",
    "loyalty": {
      "redeemed": "Points redeemed on the sale",
      "released": "Points given back on returns",
      "earnsNow": "Points the sale earns now",
      "toEarnNow": "Points the sale earns once paid"
    }
  },
  "shiftReturns": {
    "title": "Returns",
    "empty": "No returns on this shift.",
    "creditNote": "Credit note",
    "sale": "Sale",
    "method": "Refund",
    "amount": "Amount",
    "methods": {
      "CASH": "Cash",
      "CARD": "Card",
      "STORE_CREDIT": "Store credit"
    },
    "reprintNamed": "Reprint the return receipt of {{number}}",
    "openNamed": "Open return {{number}}"
  },
  "returnPage": {
    "summary": "Return"
  },
  "cash": {
    "title": "Pay in / pay out",
    "body": "Move cash between this drawer and the safe or bank.",
    "direction": "Direction",
    "out": "Pay out",
    "in": "Pay in",
    "outHint": "Cash leaves the drawer, e.g. a bank drop.",
    "inHint": "Cash comes into the drawer, e.g. a float top-up from the safe.",
    "from": "From",
    "to": "To",
    "account": "Account",
    "amount": "Amount",
    "reason": "Reason",
    "transfer": "Transfer",
    "submitOut": "Pay out",
    "submitIn": "Pay in",
    "doneOut": "{{amount}} paid out of the drawer.",
    "doneIn": "{{amount}} paid into the drawer."
  },
  "movement": {
    "in": "Pay in",
    "out": "Pay out"
  },
  "sales": {
    "title": "Sales",
    "titleOf": "Sales of shift {{number}}",
    "empty": "No sales on this shift yet.",
    "time": "Time",
    "invoice": "Invoice",
    "customer": "Customer",
    "total": "Total",
    "status": "Status",
    "actions": "Actions",
    "reprint": "Reprint",
    "reprintNamed": "Reprint the receipt of {{number}}",
    "open": "Receipt",
    "openNamed": "Open sale {{number}}"
  },
  "void": {
    "action": "Void",
    "named": "Void sale {{number}}",
    "title": "Void sale {{number}}?",
    "body": "Its payments and invoice are reversed and the goods go back into stock. A sale with returns can't be voided.",
    "confirm": "Void sale",
    "done": "Sale {{number}} voided."
  },
  "clear": {
    "title": "Clear this sale?",
    "body": "Every item, the customer and the discount are removed.",
    "confirm": "Clear sale"
  },
  "close": {
    "title": "Close shift {{number}}",
    "body": "Count every note and coin in the drawer.",
    "pendingSale": "The sale on screen isn't paid: closing the shift discards it.",
    "count": "Drawer count",
    "value": "Note or coin",
    "countHeader": "Count",
    "amount": "Amount",
    "countOf": "Count of {{value}}",
    "counted": "Counted",
    "expected": "Expected",
    "variance": "Difference",
    "blindTitle": "Blind close",
    "blind": "Count what is in the drawer. The expected amount and any difference appear on the Z report.",
    "notes": "Notes",
    "notesHint": "Optional: anything the supervisor should know.",
    "keys": "Enter moves to the next count.",
    "submit": "Close shift",
    "confirmTitle": "Close shift {{number}}?",
    "confirmBody": "The drawer count of {{amount}} is final, and nothing more can be sold on this shift."
  },
  "closed": {
    "title": "Shift {{number}} is closed",
    "body": "Print the Z report for the drawer bag, then open a new shift or return to the back office.",
    "print": "Print Z report",
    "openNew": "Open a new shift"
  },
  "report": {
    "x": "X report",
    "z": "Z report",
    "xTitle": "X report of {{number}}",
    "zTitle": "Z report of {{number}}",
    "xNote": "Figures so far; the shift is still open.",
    "till": "Till",
    "cashier": "Cashier",
    "opened": "Opened",
    "closed": "Closed",
    "closedBy": "Closed by",
    "sales": "Sales",
    "salesCount": "Sales ({{count}})",
    "discounts": "Discounts",
    "vat": "VAT",
    "voided": "Voided ({{count}})",
    "tenders": "Payments",
    "cash": "Cash",
    "card": "Card",
    "bankTransfer": "Bank transfer",
    "other": "Other",
    "returns": "Returns",
    "returnsCount": "Returns ({{count}})",
    "cashRefunds": "Cash refunds",
    "cardRefunds": "Card refunds",
    "storeCredit": "Store credit",
    "drawer": "Drawer",
    "openingFloat": "Opening float",
    "cashSales": "Cash sales",
    "payIns": "Pay-ins",
    "payOuts": "Pay-outs",
    "expected": "Expected cash",
    "counted": "Counted cash",
    "variance": "Difference",
    "denominations": "Count",
    "movements": "Pay-ins and pay-outs",
    "generated": "Printed {{time}}",
    "backToSale": "Back to the sale",
    "byMethod": "By payment method",
    "methodCount": "{{name}} ({{count}})"
  },
  "variance": {
    "surplus": "Surplus",
    "shortage": "Shortage",
    "balanced": "Balanced"
  },
  "shiftStatus": {
    "OPEN": "Open",
    "CLOSED": "Closed"
  },
  "saleStatus": {
    "COMPLETED": "Completed",
    "VOID": "Void"
  },
  "shifts": {
    "title": "Shifts",
    "subtitle": "Till shifts with their drawer counts and differences.",
    "statusFilter": "Status",
    "allStatuses": "All statuses",
    "tillFilter": "Till",
    "allTills": "All tills",
    "empty": "No shifts yet",
    "emptyBody": "Shifts appear here once a cashier opens one at the till.",
    "fields": {
      "number": "Shift",
      "till": "Till",
      "cashier": "Cashier",
      "opened": "Opened",
      "closed": "Closed",
      "float": "Float",
      "expected": "Expected",
      "counted": "Counted",
      "variance": "Difference",
      "status": "Status"
    },
    "stats": {
      "label": "Shift figures",
      "open": "Open now",
      "openDetail": "Floats {{float}}",
      "netSales": "Net till sales",
      "netSalesDetail": "{{month}} · after returns",
      "trend": "Net till sales by month, {{from}} to {{to}}",
      "short": "Cash short",
      "shortDetail": "{{month}} · {{shifts}} · over {{over}}",
      "closed": "Closed",
      "closedDetail": "Counted and closed",
      "shifts_one": "{{n}} shift short",
      "shifts_other": "{{n}} shifts short"
    }
  },
  "shift": {
    "summary": "Shift",
    "notes": "Notes",
    "printX": "Print X report",
    "printZ": "Print Z report",
    "noMovements": "No pay-ins or pay-outs on this shift."
  },
  "sale": {
    "subtitle": "Till {{till}} · {{time}}",
    "summary": "Sale",
    "invoice": "Invoice",
    "shift": "Shift",
    "tenders": "Payments",
    "voidTitle": "This sale was voided",
    "voidReason": "Reason: {{reason}}",
    "noVoid": {
      "title": "This sale can no longer be voided",
      "closed": "Its shift is closed.",
      "returned": "Goods from it were returned.",
      "otherShift": "It is on another cashier's shift: a shift manager can void it."
    }
  },
  "tills": {
    "title": "Tills",
    "subtitle": "Each till sells from one warehouse, keeps cash in its drawer and takes card payments into its card account.",
    "new": "New till",
    "newTitle": "New till",
    "newSubtitle": "A till for the counter.",
    "editTitle": "Edit till",
    "editNamed": "Edit till {{code}}",
    "save": "Save till",
    "actions": "Actions",
    "active": "In use",
    "inactive": "Not in use",
    "activeLabel": "In use",
    "cashOnly": "Cash only",
    "noCard": "None (cash only)",
    "choose": "Choose…",
    "empty": "No tills yet",
    "emptyBody": "Add a till to start selling at the counter.",
    "openShiftNote": "Open shifts on this till: {{count}}. It stays in use and keeps its drawer until they close.",
    "sharedDrawer": "Till {{tills}} also uses this drawer: only one till on a drawer can have a shift open at a time.",
    "officeCash": "Office cash too",
    "officeCashNote": "This drawer is also the office's cash account. Office receipts, payments and expenses would change what the till expects to count, so they can't use it now. Give the till a drawer of its own and the office gets its cash account back.",
    "ownDrawer": {
      "action": "Give this till its own drawer",
      "hint": "A new cash account becomes the drawer, so only the till moves money in it.",
      "openShift": "Close the shift open on this till first.",
      "title": "Give till {{code}} its own drawer",
      "body": "A new cash account, {{name}}, becomes this till's drawer. {{old}} stays with the office.",
      "accountName": "Till drawer {{code}}",
      "cash": "Cash in the drawer now",
      "cashHint": "Count the drawer: this amount moves from {{old}} to the new drawer. Enter 0 if it is empty.",
      "submit": "Give it its own drawer",
      "toast": "Till {{code}} now has its own drawer, {{name}}.",
      "nameTaken": "A cash or bank account named {{name}} already exists. Choose it as the drawer on the till form, or rename it first."
    },
    "fields": {
      "code": "Code",
      "name": "Name",
      "nameAr": "Name (Arabic)",
      "warehouse": "Warehouse",
      "drawer": "Drawer (cash account)",
      "card": "Card account",
      "openShifts": "Open shifts",
      "status": "Status"
    },
    "hints": {
      "code": "Up to 32 letters, digits, dashes or underscores, e.g. TILL-01.",
      "warehouse": "Stock for this till's sales is issued from here.",
      "drawer": "The cash account for this till's drawer.",
      "card": "A card terminal or bank account; none means the till takes cash only.",
      "active": "A till not in use can't open shifts."
    },
    "toast": {
      "created": "Till {{code}} added.",
      "updated": "Till {{code}} saved."
    },
    "errors": {
      "codeTaken": "Another till already uses this code.",
      "version": "Someone else changed this till. Close and open it again to see the latest version."
    }
  },
  "errors": {
    "INSUFFICIENT_STOCK": "Not enough stock for this sale. Your stock policy blocks sales that take stock below zero: remove or reduce these items, then take payment again.",
    "stockInventoryOff": "Inventory is turned off for your company, so stock can't be transferred or counted. A manager can change the stock policy in Settings › Inventory.",
    "CASH_ONLY_TILL": "This till takes cash only. Take the payment in cash.",
    "CREDIT_NOT_ALLOWED": "This customer can't buy on account at the till. Take the payment in full.",
    "TILL_CREDIT_NEEDS_SALES": "Selling on account needs the Sales module, which is turned off for your company. Take the payment in full.",
    "TENDER_MISMATCH": "The payments don't add up to the sale total.",
    "TENDER_EXCEEDS_DUE": "A card payment is more than what is still due.",
    "DISCOUNT_CONFLICT": "A discount on the whole sale can't be combined with line discounts. Remove those first.",
    "SHIFT_CLOSED": "This shift is closed. Open a new shift to go on selling.",
    "SHIFT_NOT_YOURS": "This shift belongs to another cashier.",
    "SALE_HAS_RETURNS": "Goods from this sale were returned, so it can no longer be voided.",
    "SALE_CREDITED": "A credit note was posted against this sale in the back office, so it can no longer be voided.",
    "SALE_VOID": "This sale was voided; nothing can be returned against it.",
    "NO_CARD_PAYMENT": "This sale wasn't paid by card. Refund it in cash.",
    "WALK_IN_NO_CREDIT": "The walk-in customer is refunded at once; store credit needs a named customer.",
    "STORE_CREDIT_NEEDS_SALES": "Store credit needs the Sales module, which is turned off for your company. Refund in cash or by card.",
    "TERMINAL_INACTIVE": "This till isn't in use. Choose another till or ask a manager.",
    "TERMINAL_HAS_OPEN_SHIFT": "A shift is open on this till. Close it before taking the till out of use or changing its drawer.",
    "DRAWER_IN_USE": "Another till that uses the same drawer has a shift open. Close that shift before opening one here.",
    "DRAWER_ARCHIVED": "This till's drawer account is archived. A manager needs to choose another drawer for the till first.",
    "TILL_WAREHOUSE_ARCHIVED": "This till's warehouse is archived. A manager needs to choose another warehouse for the till first.",
    "DRAWER_NOT_CASH": "This till's drawer account is no longer a cash account. A manager needs to choose another drawer for the till first.",
    "TILL_CARD_ACCOUNT_UNUSABLE": "This till's card account is archived or is no longer a card terminal or bank account. Use cash instead, or ask a manager to choose another card account for the till.",
    "REFUND_ACCOUNT_UNUSABLE": "The account this sale's card payment went into is archived or is now a cash account, so the card refund can't go back there. Refund it in cash (more than the sale took in cash needs a supervisor), or keep it as store credit.",
    "CARD_REFUND_EXCEEDS_CARD": "Only {{amount}} of this sale can still go back to the card it was paid by. Return fewer items to the card and refund the rest in cash, or keep it as store credit.",
    "REFUND_TENDER_NEEDS_OVERRIDE": "Only {{amount}} of this sale was paid in cash and can still go back in cash. Refund it the way the sale was paid, or ask a supervisor who may refund any tender.",
    "methodIntoCash": "This payment method goes into a cash account, so the till can't take it. Take another payment method, or ask a manager to give the method a card terminal, bank or wallet account.",
    "RETURN_EXCEEDS_SOLD": "That is more than is left to return on the sale.",
    "INSUFFICIENT_FUNDS": "The account the cash comes from doesn't hold this much today. Lower the amount or choose another account.",
    "WHOLE_UNITS_ONLY": "This item is counted in whole units.",
    "SERIAL_COUNT_MISMATCH": "A serial-tracked item needs one serial number per unit. Check the serial numbers on the marked line.",
    "SERIAL_NOT_AVAILABLE": "No longer in stock at this till: {{serials}}. Choose other serial numbers on the marked line.",
    "SERIAL_NOT_SOLD": "Not sold on this line of the sale, or already returned: {{serials}}.",
    "SERIAL_TAKEN": "Already in stock, sold, or listed twice: {{serials}}. A sold serial number comes back only through its sale's return.",
    "SERIAL_DUPLICATE": "A serial number is listed more than once: {{serials}}.",
    "SERIALS_NOT_TRACKED": "The marked item no longer tracks serial numbers. Remove it and scan it again.",
    "SERIAL_MOVED_ON": "A serial number of this sale has moved on since (sold again, returned or transferred): {{serials}}.",
    "priceOverride": "Changing prices or giving discounts needs the price override permission.",
    "alreadyOpen": "A shift is already open on this till. Close it before opening another.",
    "LOYALTY_REDEMPTION_CHANGED": "The points this sale can take have changed (the customer's balance, the sale or the programme). Check the points and the new total, then take payment again.",
    "LOYALTY_BALANCE_CHANGED": "The customer's points balance changed meanwhile (points were spent elsewhere). Check the points and the new total, then take payment again."
  },
  "salesperson": {
    "label": "Salesperson",
    "default": "The customer’s salesperson, else you",
    "none": "No salesperson",
    "change": "Change",
    "changeLabel": "Change salesperson",
    "title": "Salesperson for this sale",
    "body": "Who is credited with this sale for commission.",
    "useDefault": "Customer’s or mine",
    "me": "Me"
  }
}
